import React from 'react';
import { studyCalculators } from './ConstantsStudyCalculator';
import SharedHelmet from '.././Helmet'
import img from '../../../images/StudyCalculatorImg.webp';
const TITLE = 'حواسب الدراسة - حواسب مجانية لحساب المعدل التراكمي وتقدير الدرجات';
const DESCRIPTION = 'استكشف مجموعة حواسب الدراسة المجانية، بما في ذلك حواسب حساب المعدل التراكمي وتحويل الدرجات بين نظم التقدير المختلفة.';
const KEYWORDS = 'حواسب الدراسة، حواسب مجانية، حاسبة المعدل التراكمي، حاسبة تحويل الدرجات، GPA، نظام التقدير';
const OG_URL = 'https://do-calculate.com/ar/study-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th className="gpa-header">الحاسبة</th>
                        <th className="gpa-header">الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {studyCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
